import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import Moment from "moment";
import { Component, default as React } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import Select from 'react-select';


const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class RCASuppressionList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            suppressions: [],
            
            
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            dataSetPrimaryKey: "owner_is_company_keyword_result_id"
        };

        
    }
    

    async componentDidMount() {
        console.log("In RCASuppressionList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        
        try {
            const suppressions = await this.getSuppressions();
            this.setState({ suppressions: suppressions});
        } catch (e) {
            alert(e);
        }
        document.title = "RCA Manual Suppression List";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ suppressions: [] });        
    }


    
    async getSuppressions() {
        console.log("Inside getSuppressions() ");
        
        return API.get("colin", "/slmmanualsuppressions");
      
    }

    

    addRecord = async event => {
        let suppressions = [...this.state.suppressions];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        suppressions.unshift({
            
            search_string: "",
            search_option: null,
            notes: "",           
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({suppressions});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/slmmanualsuppressions/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/slmmanualsuppressions/${record["owner_is_company_keyword_result_id"]}`, {
            body: record
        });
        
        

       
    }

    validateRecord(record) {

 
        //Check street name not blank
        if (record.group_id === null) {
            return [false,"You must select a group. The record has not been saved"];
        }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let suppressions = [...this.state.suppressions];

        var indexOfRecord = suppressions.findIndex(i => i.owner_is_company_keyword_result_id === cellInfo.original.owner_is_company_keyword_result_id);
        console.log("Index = "+ indexOfRecord);
        suppressions[indexOfRecord][cellInfo.column.id] = event.target.value;
        suppressions[indexOfRecord].modified = true;
        this.setState({suppressions});
        

    };
    handleNumberChange = (cellInfo, event) => {
        let suppressions = [...this.state.suppressions];

        let val = event.target.value.replace(/[^0-9.]/g, "");
        var indexOfRecord = suppressions.findIndex(i => i.owner_is_company_keyword_result_id === cellInfo.original.owner_is_company_keyword_result_id);
        suppressions[indexOfRecord][cellInfo.column.id] = Number(val);
        suppressions[indexOfRecord].modified = true;
        this.setState({suppressions});
        
    };
    handleCheckboxChange = (cellInfo, event) => {
        let suppressions = [...this.state.suppressions];

        var indexOfRecord = suppressions.findIndex(i => i.owner_is_company_keyword_result_id === cellInfo.original.owner_is_company_keyword_result_id);
        suppressions[indexOfRecord][cellInfo.column.id] = event.target.checked;
        suppressions[indexOfRecord].modified = true;
        this.setState({suppressions});
       
    };

    handleDateChange = (cellInfo, event) => {
        let suppressions = [...this.state.suppressions];
        var indexOfRecord = suppressions.findIndex(i => i.owner_is_company_keyword_result_id === cellInfo.original.owner_is_company_keyword_result_id);
        suppressions[indexOfRecord][cellInfo.column.id] = new Date(event);
        suppressions[indexOfRecord].modified = true;
        this.setState({suppressions});
   
    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let suppressions = [...this.state.suppressions];
        for (var i=0; i<suppressions.length; i++){
            if (suppressions[i].hasOwnProperty("modified")) {
                if (suppressions[i].modified === true) {
            const validation = this.validateRecord(suppressions[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                
                    
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (suppressions[i].hasOwnProperty("new_record")) {
                                if (suppressions[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(suppressions[i]);
                            if (result.result) {
                                suppressions[i].modified = false;
                                if (suppressions[i].hasOwnProperty("new_record")) {
                                    if (suppressions[i].new_record === true) {

                                        suppressions[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    suppressions[i].new_record = false;
                                    
                                }
                                else{
                                    const suppressions = await this.getSuppressions();
                                    this.setState({ suppressions });
                                }
                                
                                                               
                            }
                            else {
                                suppressions[i].issue_date = null;
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    

                
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }
        }
        }   
        if (suppressions[0].hasOwnProperty("sort_order")) {
            suppressions.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({suppressions});

    }

    handleDropDownChange = (cellInfo, event) => {
        let suppressions = [...this.state.suppressions];
        var indexOfRecord = suppressions.findIndex(i => i.owner_is_company_keyword_result_id === cellInfo.original.owner_is_company_keyword_result_id);
        suppressions[indexOfRecord][cellInfo.column.id] = event.value;
        suppressions[indexOfRecord].group_name = event.label;
        suppressions[indexOfRecord].modified = true;
        this.setState({suppressions}); 
           

    }

    renderEditable = cellInfo => {
        const cellValue = this.state.suppressions[cellInfo.index][cellInfo.column.id];
        // if(1==2){ //temporarily removing editing


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}        
                                />
                            );
                        }
        }
    // }
    }

    
    
    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete tree");
        let suppressions = [...this.state.suppressions];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);
            suppressions[cellInfo.index].archived = true;
            suppressions[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(suppressions[cellInfo.index]).then((result) => {
                suppressions.splice(cellInfo.index, 1);
                this.setState({suppressions});
            }
            )
        };
    };
    
      
    
    renderTable(data) {
        const columns = [
            
            {
                id: 'owner_is_company_keyword_result_id',
                Header: 'ID',
                maxWidth: 65,
                accessor: 'owner_is_company_keyword_result_id' 
                

        }
        , {
                id: 'input_value',
                Header: 'Value',            
                accessor: 'input_value',
                maxWidth: 250,
                // Cell: this.renderEditable
                

            }
           ,
            {
                id: 'created_date',
                Header: 'Created Date',
                maxWidth: 250,
                accessor: d => {
                            if (d.created_date) {
                                return Moment(d.created_date)
                                    .local()
                                    .format("DD-MM-YYYY")
                            }
                            else { return null }
                        }
                // Cell: this.renderEditable
            }
         
            ,{
                Header: '',
                accessor: 'owner_is_company_keyword_result_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={50}
                    sortable={false}
                />
            )
        }
    }

   
    renderComponent() {
        return (
            <div className="suppressions">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
               

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>

                        {!this.state.isLoading ? this.renderTable(this.state.suppressions) : this.renderTable(this.state.suppressions)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="SuppressionsList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
